import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "headline"
};
const _hoisted_2 = {
  class: "rate-options"
};
const _hoisted_3 = ["onClick"];
import { ref } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import { storeToRefs } from 'pinia';
export default {
  __name: 'RateChangeConfirmationModal',
  emits: ['cancel', 'continue'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      terms
    } = storeToRefs(useMeStore());
    const emit = __emit;
    const rateOptions = [{
      title: `Keep rate for existing ${terms.value.matter}s`,
      description: `The new rates will apply only to new ${terms.value.matter}s, existing ${terms.value.matter}s and time entries maintain the same rate.`,
      updateMatters: false,
      updateEntries: false
    }, {
      title: `Change ${terms.value.matter}, Keep time entries`,
      description: `The new rates will apply to new time entries in existing and new ${terms.value.matter}s. Existing time entries remain the same.`,
      updateMatters: true,
      updateEntries: false
    }, {
      title: 'Change rate on everything',
      description: `The new rates will apply to new time entries in new and existing ${terms.value.matter}s and to unbilled time entries in existing ${terms.value.matter}s.`,
      updateMatters: true,
      updateEntries: true
    }];
    const selectedOption = ref(null);
    const selectOption = index => {
      selectedOption.value = index;
    };
    const continueWithSelectedOption = () => {
      if (selectedOption.value !== null) {
        const selectedRate = rateOptions[selectedOption.value];
        emit('save', {
          updateMatters: selectedRate.updateMatters,
          updateEntries: selectedRate.updateEntries
        });
      }
    };
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createBlock(_component_v_card, null, {
        default: _withCtx(() => [_createVNode(_component_v_card_title, null, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_cache[3] || (_cache[3] = _createTextVNode("Rate change ", -1)), _createVNode(_component_v_icon, {
            class: "cursor-pointer float-right text-sm",
            onClick: _cache[0] || (_cache[0] = $event => emit('cancel'))
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("mdi-close", -1)]))]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [_createElementVNode("p", null, " You are about to change billing rates; you can change rates in your existing " + _toDisplayString(_unref(terms).matter) + " and time entries or just in new " + _toDisplayString(_unref(terms).matter) + " going forward. Choose one of the three options below. ", 1), _createElementVNode("div", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(rateOptions, (option, index) => {
            return _createElementVNode("div", {
              key: index,
              class: _normalizeClass(['rate-option', {
                selected: selectedOption.value === index
              }]),
              onClick: $event => selectOption(index)
            }, [_createElementVNode("h4", null, _toDisplayString(option.title), 1), _createElementVNode("p", null, _toDisplayString(option.description), 1)], 10, _hoisted_3);
          }), 64))])]),
          _: 1
        }), _createVNode(_component_v_card_actions, null, {
          default: _withCtx(() => [_createVNode(LlSecondaryButton, {
            onClick: _cache[1] || (_cache[1] = $event => emit('cancel'))
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode(" Cancel ", -1)]))]),
            _: 1
          }), _createVNode(_component_v_spacer), _createVNode(LlSecondaryButton, {
            color: "primary",
            onClick: continueWithSelectedOption
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" Continue ", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};